import React from 'react';
import {classes, st} from './TotalUpdateSkeleton.st.css';
import {SkeletonLineWrapper} from '../../../../../../common/components/Skeleton/SkeletonLine/SkeletonLineWrapper';

export enum TotalUpdateSkeletonDataHooks {
  Loader = 'TotalUpdateSkeletonDataHooks.Loader',
}

export const TotalUpdateSkeleton = ({size}: {size?: 'small' | 'medium'}) => (
  <SkeletonLineWrapper
    dataHook={TotalUpdateSkeletonDataHooks.Loader}
    className={st(classes.skeleton, size && classes[size])}
  />
);
